 {
    "common": {
    "thisWeek": "Cette semaine",
    "lastWeek": "La semaine dernière",
    "lastNumberOfDays": "Les {numberOfDays} derniers jours",
    "thisMonth": "Ce mois-ci"
    },
    "subAccounts": "Sous-comptes",
    "submitFeedback": "Soumettre une rétroaction",
    "createSubAccount": "Créer un sous-compte",
    "viewScheduleReports": "Voir les rapports planifiés",
    "searchSubAccount": "Rechercher par sous-compte",
    "columns": "Colonnes",
    "sortBy": "Trier par",
    "selectColumns": "Sélectionner des colonnes",
    "maxColumns": "Max de 8 colonnes à une Date",
    "applyColumns": "Appliquer des colonnes",
    "activeUsers": "Utilisateurs actifs",
    "appointments": "Rendez-vous",
    "contacts": "Contacts",
    "emails": "Gmail",
    "textMessages": "Messages du corps",
    "calls": "Appels",
    "submissions": "Soumissions",
    "reviews": "avis",
    "sitesCreated": "Sites créés",
    "name": "Nom",
    "formSubmissions": "Soumissions de formulaires",
    "surveySubmissions": "Soumissions de sondages",
    "facebookFormSubmissions": "Soumissions de formulaires Facebook",
    "funnels": "Entonnoirs",
    "websites": "Sites Web",
    "forms": "Formulaires",
    "surveys": "Sondages",
    "highestFirst": "Max d’abord",
    "lowestFirst": "Le plus de base à bord",
    "orderBy": "Essai via",
    "noMoreLocations": "Aucune adresse n'a été trouvée",
    "preparingReport": "Nous préparons votre rapport…",
    "preparingReportDesc": "Ne fermez pas ou n'actualisez pas cette fenêtre pendant que l’exportation est en cours.",
    "outOf": "Dé",
    "subAccountsExported": "Sous-comptes exportés",
    "close": "Fermer",
    "scheduledForDeletion": "Prévu pour la suppression",
    "readyToSell": "Prêt à vendre",
    "closedWon": "Fermé (gagné)",
    "wpSaleSuccessful": "La vente WordPress est réussie",
    "wpNotSold": "WordPress non encore exporté",
    "yxtSaleSuccessful": "La vente actuelle est réussie",
    "yxtNotSold": "Pas encore de ventes",
    "saasSubInactive": "L'abonnement SaaS est inactif",
    "saasSubTrialing": "L'abonnement SaaS est en cours d'essai",
    "saasSubActive": "L'abonnement SaaS est dynamique",
    "emailRebillingActive": "La réorganisation du courriel est dynamique",
    "emailRebillingInactive": "La réorganisation du courriel est inactif",
    "twilioRebillingActive": "Twilio Refacturation est dynamique",
    "twilioRebillingInactive": "Twilio refacturation est inactif",
    "wpRebillingActive": "La refacturation WhatsApp est active.",
    "wpRebillingInactive": "La refacturation WhatsApp est inactive.",
    "saasModeActivated": "Le mode SaaS est activé",
    "paymentPending": "Le Paiement est en attente",
    "saasModeNotActivated": "Le mode SaaS n'est pas activé",
    "managedByLCPhone": "Personnaliser via UC Téléphone",
    "migrationToLCPhone": "En cours de conversion vers le Téléphone UC",
    "notManagedByLCPhone": "Ne pas gérer via UC Téléphone",
    "managedByLCEmail": "Gérer via LeadConnector Email System",
    "notMangedByLCEmail": "Ne pas gérer le système via LeadConnector Email System",
    "remainingWalletBalance": "Solde disponible dans le portefeuille de cet emplacement SaaS",
    "reports": "Rapports",
    "switchToSubAccount": "Passer au sous-compte",
    "manageClient": "Gérer le client",
    "subAccountDeletedIfChangedMind": "Ce sous-compte sera supprimé à {time}, si vous avez changé d'avis.",
    "subAccountDeletedInMinute": "Ce sous-compte sera supprimé dans la minute qui suit.",
    "changedMind": "Si vous avez dynamique votre tête",
    "clickHere": "Voir ici",
    "subAccountPaused": "Ce sous-compte est mis en pause. Vos clients ne peuvent pas se connecter, mais l'agence le peut. Pour réactiver ce compte",
    "subAccountRestricted": "Ce sous-compte est mis en pause en attendant une approbation.",
    "subAccountVerificationPending": "Ce sous-compte est mis en pause en raison de la vérification du courriel et du téléphone par l'administrateur du sous-compte, en attente.",
    "subAccountDeclined": "Ce sous-compte est mis en pause en raison d'une demande d'approbation rejetée. Vous pouvez toujours réactiver ce sous-compte à partir de ",
    "here": "ici.",
    "reviewAndResume": "pour examiner et réactiver ce sous-compte.",
    "incomingCalls": "Appels entrants",
    "outgoingCalls": "Appels sortants",
    "totalTalktime": "Total des conversations",
    "incomingEmails": "Gmailentrant",
    "outgoingEmails": "Gmailsortant",
    "incomingSms": "Messages entrants du corps",
    "outgoingSms": "Messages sortants",
    "contactsCreated": "Nombre total de contacts créés",
    "appointmentsBooked": "Nombre total de rendez-vous pris",
    "totalFormSubmissions": "Total des soumissions de formulaires",
    "totalSurveySubmissions": "Total des soumissions de l'enquête",
    "totalFacebookFormSubmissions": "Total des soumissions de formulaires Facebook",
    "incomingGMBMessages": "Messages GBP entrants",
    "outgoingGMBMessages": "Messages GBP sortants",
    "gmbMessages": "Messages GBP",
    "fbMessages": "Messages Facebook",
    "incomingFbMessages": "Messages entrants Facebook",
    "outgoingFbMessages": "Messages sortants Facebook",
    "igMessages": "Messages Instagram",
    "incomingIgMessages": "Instagram entrants",
    "outgoingIgMessages": "Messages Instagram",
    "totalReviews": "Total des commentaires",
    "positiveReviews": "Commentaires Positif",
    "negativeReviews": "Évaluation négative",
    "back": "Retour",
    "selectDashboards": "Sélectionner des tableaux de bord",
    "next": "Suivant",
    "backToSubAccounts": "Retour aux sous-comptes",
    "pauseSchedule": "Pause du calendrier",
    "resumeSchedule": "Reprendre la planification",
    "editSchedule": "Modifier l'horaire",
    "addSchedule": "Ajouter un horaire",
    "selectReportToAdd": "Sélectionner des rapport à inclure in le courriel",
    "selectAll": "Sélectionner tout",
    "pauseScheduleConfirm": "Êtes-vous sûr de vouloir Pause le rapport?",
    "resumeScheduleConfirm": "Êtes-vous sûr de vouloir reprendre la planification du rapport ?",
    "tasks": "Tâches",
    "conversations": "Conversations",
    "users": "Utilisateur",
    "dealOverview": "Aperçu de la Accord",
    "confirmAction": "Confirmer l'action",
    "yes": "Oui",
    "no": "Non",
    "reportDetails": "Détails du rapport",
    "reportCreatedOn": "Rapport sur l'ensemble du rapport",
    "searchByEmail": "Recherche via Courriel",
    "lastActivity": "Dernière activité",
    "noRecords": "Aucun enregistrement trouvé",
    "scheduleReport": "Planifier le rapport",
    "schedule": "Calendrier",
    "save": "Enregistrer",
    "emailSubject": "Ligne d'objet",
    "frequency": "Fréquence",
    "daily": "Quotidiennement",
    "weekly": "Hebdomadaire",
    "monthly": "Mensuel",
    "nextScheduleDate": "Date",
    "startingOn": "Allumé de début",
    "timeOfDay": "Date de jour",
    "reportsToTimezone": "Le rapport sera envoyé dans le fuseau horaire du sous-compte.",
    "selectRecipients": "Sélectionner des destinataires",
    "invalidEmail": "Saisissez une adresse courriel valide.",
    "testEmail": "Courriel de Essai",
    "selectTestRecipients": "Sélectionner des destinataires d'essai",
    "setupSubject": "Configurer les Sujet ci-dessus pour essayer le rapport",
    "sendTest": "Téléverser des essais",
    "scheduleSimilarSchedules": "Planifiez un rapport similaire pour les autres sous-comptes.",
    "accountSummary": "Résumé du compte",
    "scheduleList": "Planifier la liste",
    "subAccountName": "Nom du sous-compte",
    "nextRunDate": "Prochaine date d'exécution",
    "reportSectionsAdded": "Sections du rapport ajoutées",
    "status": "Statut",
    "scheduleAction": "Planifier une action",
    "cancel": "Annuler",
    "pleaseWait": "Chargement…",
    "confirm": "Confirmer",
    "booked": "Réservé",
    "confirmed": "Confirmé",
    "showed": "Montré",
    "noShow": "Absent",
    "cancelled": "Annulé",
    "unread": "Non lus",
    "engagement": "Affectation",
    "reaction": "Réaction",
    "deliverySummary": "Résumé de la livraison",
    "successfulDelivery": "Livraison réussie",
    "opened": "Ouvert",
    "clicked": "Cliqué",
    "replied": "Répondu",
    "unsubscribed": "Désabonné",
    "complained": "Plainte",
    "failed": "Échec",
    "bounced": "Rebondir",
    "open": "Ouvert",
    "won": "Gagné",
    "abandoned": "Abandonné",
    "lost": "Perdu",
    "sent": "Envoyé",
    "eject": "Éjeter",
    "delivered": "Livré",
    "faceBookLeadForm": "Formulaire de prospect Facebook",
    "overdue": "En retard",
    "reviewsReceived": "D'avis",
    "formBuilders": "Générateurs de formulaires",
    "switchToSaaS": "Passer au SaaS",
    "numberOfContacts": "Nombre total de contacts",
    "numberOfAppointments": "Nombre total de rendez-vous",
    "outreach": "Extension",
    "notSubAccountUser": "N'est pas un utilisateur de sous-compte",
    "searchSubAccName": "Rechercher par nom de sous-compte",
    "recipients": "Reçus",
    "scheduleCreated": "Planification d'envoi du rapport par courriel créée pour ",
    "scheduleUpdated": "Planification d'envoi du rapport par courriel mise à jour pour ",
    "scheduleNotCreated": "La planification d'envoi du rapport par courriel n’a pas pu être créée pour",
    "scheduleNotUpdated": "La planification d'envoi du rapport par courriel n’a pas pu être mise à jour pour",
    "total": "Total",
    "inbound": "entrant",
    "outbound": "Sortie",
    "totalEmails": "Total des courriels",
    "inboundEmails": "Courriels entrants",
    "outboundEmails": "Courriels sortants",
    "totalTextMessages": "Nombre total de messages texte",
    "inboundTextMessages": "Messages texte entrants",
    "outboundTextMessages": "Messages texte sortants",
    "totalCalls": "Nombre total d'appels",
    "inboundCalls": "Appels entrants",
    "outboundCalls": "Appels sortants",
    "faceBookLeadFormSubmissions": "Soumissions de formulaires de prospects Facebook",
    "inboundGMBMessages": "Messages GBP entrants",
    "outboundGMBMessages": "Messages GBP sortants",
    "totalIgMessages": "Nombre total de messages Instagram",
    "inboundIgMessages": "Messages Instagram entrants",
    "outboundIgMessages": "Messages Instagram sortants",
    "totalfbMessages": "Nombre total de messages Facebook",
    "inboundfbMessages": "Messages Facebook entrants",
    "outboundfbMessages": "Messages Facebook sortants",
    "sitesCreatedFunnels": "Sites créés - entonnoirs",
    "sitesCreatedActiveFunnels": "Sites créés – entonnoirs actifs",
    "sitesCreatedWebsites": "Sites créés – sites Web",
    "sitesCreatedActiveWebsites": "Sites créés – sites Web actifs",
    "sitesCreatedForms": "Sites créés - formulaires",
    "sitesCreatedActiveForms": "Sites créés - formulaires actifs",
    "sitesCreatedSurveys": "Sites créés – sondages",
    "sitesCreatedActiveSurveys": "Sites créés – sondages actifs",
    "googleReviews": "Avis Google",
    "facebookReviews": "Avis Facebook",
    "inboundCallDuration": "Durée des appels entrants (heures)",
    "outboundCallDuration": "Durée des appels sortants (heures)",
    "pleaseSelect": "Sélectionner",
    "subAccountIsDeleted": "Ce sous-compte a été supprimé.",
    "subAccountIsPaused": "Ce sous-compte a été mis en pause.",
    "success": "Succès",
    "error": "Erreur",
    "testEmailSent": "Courriel de Essai envoyé",
    "testEmailNotSent": "Courriel d’essai n’a pas pu être envoyé",
    "reviewRequest": "Demandes de rétroaction",
    "pendingTransferDescription": "D'autres agences ont demandé de vous transférer des sous-comptes.",
    "pendingTransferHeading": "Vous avez des demandes de transfert de sous-compte en attente.",
    "subAccountTransfer": "Transferts de sous-comptes",
    "manageSubAccTransfer": "Gérer les demandes de transfert de vos sous-comptes",
    "subAccRequest": "Demandes de sous-comptes {tabName}",
    "receive": "Hériter",
    "send": "Envoyer",
    "release": "Version",
    "requests": "{count} demandes",
    "subAccLimit": "La limite d'utilisation des sous-comptes a été atteinte.",
    "subAccPlanLimit": "Vous avez utilisé 3/3 sous-comptes autorisés par votre forfait actuel.",
    "upgradeTime": "Il est temps de faire une mise à niveau!",
    "upgradeHigher": "Mettez à niveau vers un forfait supérieur pour accepter le transfert du sous-compte.",
    "browse": "Parcourir les forfaits",
    "pendingTransferTitle": "Une demande de transfert pour ce sous-compte est déjà en attente.",
    "unableTransfer": "Impossible de transférer le sous-compte à cette agence.",
    "unableEjectCancel": "Impossible d'annuler la demande d'expulsion du sous-compte.",
    "EjectErrorDetails": "La demande d'expulsion du sous-compte ne peut pas être annulée.",
    "hippaErrorDescription": "Ce sous-compte est conforme à la loi HIPAA et ne peut pas être transféré à une agence non conforme à la loi HIPAA.",
    "pendingTransferErrorDescription": "Annulez la demande de transfert existante pour ce sous-compte avant d'en créer une nouvelle.",
    "receivingAgency": "Agence destinataire",
    "releasingAgency": "Agence expéditrice",
    "noOfContacts": "Nombre total de contacts",
    "requestedDate": "Date demandée",
    "action": "Action",
    "cancelTransfer": "Annuler le transfert",
    "decline": "Rejeter",
    "cancelTransferRequest": "Annuler la demande de transfert de sous-compte?",
    "cancelEjectRequest": "Annuler la demande d'expulsion du sous-compte?",
    "cancelRequestDescription": "L'agence destinataire ne verra plus cette demande de transfert et le sous-compte {name} ne sera pas transféré.",
    "cancelEjectRequestDescription": "L'utilisateur sélectionné ne pourra plus créer de nouvelle agence à partir du sous-compte {name}.",
    "declineRequest": "Refuser la demande de transfert de sous-compte?",
    "declineRequestDescription": "La demande sera refusée et le sous-compte {name} ne sera pas transféré à votre agence.",
    "approveTransfer": "Approuver le transfert du sous-compte à votre agence?",
    "approveTransferDescription": "Le sous-compte {name} sera transféré à votre agence.",
    "transferNow": "Transférer maintenant",
    "cancelNow": "Annuler maintenant",
    "transferErrorDetails": "Ce sous-compte ne peut pas être transféré.",
    "cancelRequest": "Annuler la demande",
    "received": "Reçu",
    "approve": "Approuver",
    "goBack": "Retourner",
    "done": "Terminé",
    "subAccountTransferred": "Le sous-compte a bien été transféré!",
    "subAccountTransferDescription": "Même si le sous-compte a été transféré, certaines ressources telles que les utilisateurs, les numéros de téléphone, les comptes Mailgun et les listes Yext peuvent encore prendre 10 à 15 minutes pour apparaître dans la destination.",
    "activeSubscriptionsAlert": "L'emplacement a un abonnement dynamique. Veuillez annuler tout abonnement avant de l'emplacement à froid. Liste d'abonnements dynamiques : {subscriptions}",
    "isSaasEnabled": "SaaS activé",
    "typeToSearch": "Type pour rechercher",
    "dateAdded": "Date d’ajout",
    "emailEngagement": "Engagement par courriel",
    "emailReaction": "Réaction par courriel",
    "emailDeliverySummary": "Résumé de la livraison par courriel",
    "facebook": "Facebook",
    "sms": "Message texte",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Résumé du compte – {subAccountName}",
    "test": "Essai",
    "scheduleExists": "Un horaire existe",
    "aToZ": "A - Zoom",
    "zToA": "Zoom - A",
    "onlyAdminUsersCanAddNewSubAccounts": "Seuls les utilisateurs administrateurs peuvent ajouter de nouveaux sous-comptes.",
    "locationName": "Nom de l’emplacement",
    "transferCompleted": "La demande de transfert pour cet emplacement a déjà été traitée. Actualiser la page.",
    "unauthorizedTransfer": "Vous n'êtes pas autorisé à fournir cette Action. Seuls les propriétaires de l'agence peuvent fournir cette Action.",
    "bulkLocationTransfer": "Transfert en masse de sous-comptes",
    "singleRequest": "Demande unique",
    "bulkRequest": "Demande en masse",
    "backToLocationTransfer": "Retour au transfert d'emplacement",
    "initiateBulkTransfer": "Lancer un transfert en masse de sous-comptes",
    "initiateBulkTransferDescription": "Sélectionnez les sous-comptes que vous voulez transférer ou saisissez leurs ID séparés par des virgules.",
    "subAccountId": "ID de sous-compte",
    "selectFromList": "Sélectionnez dans la liste",
    "addManually": "Ajouter manuellement",
    "accountsSelected": "{count} sélectionné(s)",
    "selectAllSubAccounts": "Sélectionner tout",
    "removeAll": "Supprimer tout",
    "addManualLocations": "Ajoutez les ID d’emplacement séparés par des virgules.",
    "manualAllLocationIds": "Id de l'emplacement du sous-compte, vous souhaitez effectuer un transfert, séparer les coms.",
    "enterLocationIds": "Saisissez les ID des emplacements.",
    "selectSubAccounts": "Sélectionnez les sous-comptes et transférez-les à une agence existante.",
    "subAccountTransferWarning": "Tous les sous-comptes et l'utilisateur auront reçu un transfert à froid.",
    "proceed": "Poursuivre",
    "bulkRequestSubmitted": "Demande de transfert en masse soumise",
    "bulkRequestSubmittedDescription": "Chaque sous-compte sera transféré une fois que l'agence réceptrice aura accepté la demande de transfert. Vous pouvez suivre le statut de la demande sur la page « {pagename} ». (sous réserve d'admissibilité)",
    "bulkTransferRequestFailed": "La demande de transfert en masse a échoué",
    "errorLocations": "Sous-comptes avec des erreurs",
    "viewDetails": "Voir les détails",
    "somethingWrong": "Une erreur s'est produite. Veuillez réessayer.",
    "confirmBulkRequest": "Confirmer la demande de transfert en masse?",
    "bulkTransferAccounts": "Transférer en masse {count} sous-comptes sélectionnés?",
    "confirmDetails": "Confirmez les détails avant de transférer.",
    "transferConsent": "J'accepte la lecture et le consentement",
    "transferInfo": "Le transfert du sous-compte est soumis à l’acceptation de l’agence réceptrice l'acceptant dans son compte.",
    "receivingRelNo": "Numéro de relation de l'agence réceptrice",
    "enterRelNo": "Saisissez un numéro de relation.",
    "transferConfirmation": "Une fois cette Action terminée, les demandes de transfert en masse seront envoyées à l'{ relNo } Tous les sous-comptes, vous avez sélectionnés seront transfert à froid une fois que l'agence de l'agence l'accepte. Veuillez Note que cette Action est irréversible pour tout sous-compte inclus in le transfert.",
    "confirmPassword": "Confirmez en tapant via password ci-dessous",
    "enterPassword": "Saisissez le mot de passe.",
    "requestTransfer": "Demander un transfert",
    "confirmTransfer": "Confirmer le transfert",
    "notNow": "Pas maintenant",
    "invalidRelNo": "Numéro de relation non valide",
    "invalidPassword": "password non valide.",
    "searchSubAccounts": "Rechercher des sous-comptes",
    "searchSubAccountsId": "Rechercher l'ID du sous-compte",
    "takeAction": "Passer à l'action",
    "sub_account_details": "Détails du sous-compte",
    "no_of_contacts": "Nombre total de contacts",
    "transfer_status": "Statut du transfert",
    "error_info": "Informations sur l'erreur",
    "bulk_transfer_status": "Statut du transfert en masse des sous-comptes",
    "pending": "En attente",
    "processed": "Traité",
    "reject_all": "Rejeter tout",
    "accept_all": "Accepter tout",
    "cancel_all": "Annuler tout",
    "clearAll": "Tout effacer",
    "refresh": "Rafraîchir",
    "rejected": "Refuser",
    "decline_transfer": "Rejeter le transfert",
    "decline_bulk_transfer": "Refuser la demande de transfert en masse de sous-comptes?",
    "decline_bulk_transfer_description": "La demande sera refusée et les sous-comptes {length} ne seront pas transférés à votre agence.",
    "accept_bulk_transfer": "Accepter la demande de transfert en masse de sous-comptes?",
    "accept_bulk_transfer_description": "La demande sera acceptée et les sous-comptes {length} seront transférés à votre agence.",
    "cancel_bulk_transfer": "Annuler le transfert en masse ?",
    "cancel_bulk_transfer_description": "Voulez-vous vraiment annuler ce transfert en masse de sous-comptes {length} vers « {name} »?",
    "consent_sub_account_transfer": "Veuillez lire attentivement et fournir du consentement pour {link}",
    "sub_account_transfer_guidelines": "Directives relatives au transfert de sous-comptes",
    "valid_rel": "Saisissez un nombre de lien valide",
    "something_went_wrong": "Une erreur s'est produite. Veuillez réessayer.",
    "export": "Exporter",
    "export_success": "Les données que vous avez demandées sont en cours de traitement. Vous Hériter d'un courriel avec les données in une Date.",
    "export_failed": "Les données que vous avez demandées n'ont pas pu être traitée. Veuillez réessayer plus tard.",
    "selectAllError": "Vous pouvez sélectionner un maximum de 1 000 sous-comptes à la fois.",
    "max1000": "(Max 1 000)",
    "subAccountCount": "Nombre de sous-comptes",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "Êtes-vous sûr de vouloir Pause des rapport {count} ?",
    "scheduleBulkResumeConfirm": "Êtes-vous sûr de vouloir reprendre {count} rapports ?",
    "resume": "Reprendre",
    "pause": "Pause",
    "resumeSelected": "Reprendre la sélection",
    "pauseSelected": "Pause de la sélection",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} rapports sélectionnés",
    "selectAllXReports": "Sélectionner les {count} rapports",
    "scheduleStatus": "Planifier le statut",
    "scheduleSearchPlaceholder": "Rechercher en utilisant une adresse courriel ou un nom d'emplacement",
    "subAccountsPerPage": "Sous-comptes par page",
    "previous": "Précédent",
    "scheduleBulkAction": "Planifier une action en masse",
    "all": "Tous",
    "active": "Actif",
    "paused": "En pause",
    "scheduleUpdatedSuccessfully": "Mise à jour avec succès",
    "saveChanges": "Enregistrer les modifications",
    "pauseSchedulesTitle": "Pause des rapport d’aperçu",
    "pauseSchedulesDescription": "Aller à la Pause des formulaires actifs.",
    "pauseSchedulesAlert": "Cela n'affectera que les comptes qui sont désormais dynamiques.",
    "pauseAllSchedulesBtnText": "Mettre en pause tous les rapports planifiés",
    "autoScheduleTitle": "Planification automatique pour les nouveaux comptes",
    "autoScheduleLabel": "Créez automatiquement des rapports planifiés lorsqu'un nouveau sous-compte est ajouté.",
    "autoScheduleAlert": "Désactiver ce Si vous souhaitez configurer automatiquement le nouveau compte.",
    "autoScheduleEnabledForNewAccounts": "Activer le Calendrier pour le nouveau compte",
    "autoScheduleDisabledForNewAccounts": "Handicapés pour le nouveau compte",
    "deleted": "Supprimé",
    "locationPaused": "Emplacement mis en pause",
    "scheduleSettingsModalTitle": "Réglages du rapport",
    "selectAllSchedules": "Sélectionner tout le calendrier",
    "selectScheduleForLocation": "Sélectionner le calendrier pour {location}",
    "openSettings": "Réglages existants",
    "resumeScheduleForLocation": "Reprendre le calendrier pour {location}",
    "pauseScheduleForLocation": "calendrier de Pause pour {location}",
    "actions": "Actions",
    "deselectAll": "Désélectionner tout",
    "scheduleBulkActionResumeSuccess": "in cours d'activation en masse - Rester à l'écoute",
    "scheduleBulkActionPauseSuccess": "Mise en pause des rapports – attendez avant d'effectuer d'autres actions",
    "bulkActionCreationError": "Une autre action en masse est en cours. Réessayez dans un moment.",
    "bulkActionInProgress": "En masse Action déjà in cours",
    "scheduledReports": "Rapports Prévu",
    "scheduleBulkActionCompleted": "Action en masse se termine avec succès",
    "pauseAllSchedulesModalTitle": "Mettre les rapports en pause?",
    "pauseAllSchedulesModalText": "Cela mettra en pause tous les rapports planifiés actifs dans les sous-comptes.",
    "addLocationIdsPlaceholder": "Ajoutez les ID d'emplacement que vous voulez transférer…",
    "helloWorld": {
      "count": "Le nombre est {count}",
      "editIntro": "Modifier",
      "editAction": "Pour essayer HMR",
      "checkOut": "Consultez",
      "officialStarter": ", le démarreur officiel Vue + Vite",
      "install": "Installer",
      "installDescription": "dans votre IDE pour un meilleur DX",
      "learnMore": "Cliquez sur les logos Vite et Vue pour en savoir plus"
    },
    "home": {
      "testMessage": "Bonjour! Ceci est la page d’accueil du test!"
    },
    "reports": {
      "incoming": "Entrants",
      "outgoing": "Sortants",
      "duration": "Durée",
      "contactsCount": "Nombre total de contacts",
      "appointmentsCount": "Nombre total de rendez-vous",
      "formSubmissions": "Soumissions de formulaires",
      "surveySubmissions": "Soumissions de sondages",
      "facebookFormSubmissions": "Soumissions de formulaires Facebook",
      "funnels": "Entonnoirs",
      "websites": "Sites Web",
      "forms": "Formulaires",
      "surveys": "Sondages",
      "gbpMessages": "Messages GBP",
      "facebookMessages": "Messages Facebook",
      "instagramMessages": "Messages Instagram",
      "reviews": "Avis",
      "positives": "Avantages",
      "negatives": "Négatifs"
    },
    "timeOptions": {
      "00": "00 h 00",
      "01": "01 h 00",
      "02": "02 h 00",
      "03": "03 h 00",
      "04": "04 h 00",
      "05": "05 h 00",
      "06": "06 h 00",
      "07": "07 h 00",
      "08": "08 h 00",
      "09": "09 h 00",
      "10": "10 h 00",
      "11": "11 h 00",
      "12": "12 h 00",
      "13": "13 h 00",
      "14": "14 h 00",
      "15": "15 h 00",
      "16": "16 h 00",
      "17": "17 h 00",
      "18": "18 h 00",
      "19": "19 h 00",
      "20": "20 h 00",
      "21": "21 h 00",
      "22": "22 h 00",
      "23": "23 h 00"
    },
    "transferStatus": {
      "pending": "En attente",
      "processed": "Traité",
      "canceled": "Annulé",
      "cancelled": "Annulé",
      "completed": "Terminé",
      "rejected": "Refusé",
      "failed": "Échec",
      "payment_pending": "Paiement en attente"
    }
    }
